var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.263,
    height: 20.136,
    viewBox: "0 0 18.263 20.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16362",
    "data-name": "Path 16362",
    d: "M15.83,10.381h0a.7.7,0,0,1-.7.7H7.635a.7.7,0,1,1,0-1.4h7.492A.7.7,0,0,1,15.83,10.381Zm-3.512,3.044H7.635a.7.7,0,1,0,0,1.4h4.683a.7.7,0,0,0,0-1.4Zm8.195-6.953v11.1a3.444,3.444,0,0,1-3.819,3.817H6.069A3.446,3.446,0,0,1,2.25,17.568V6.472A3.446,3.446,0,0,1,6.069,2.655h.448v-.7h0a.7.7,0,1,1,1.4,0h0v.7h2.757v-.7h0a.7.7,0,0,1,1.4,0h0v.7h2.757v-.7h0a.7.7,0,0,1,1.4,0h0v.7h.448a3.446,3.446,0,0,1,3.819,3.817Zm-1.4,0c0-1.686-.722-2.413-2.414-2.413h-.448v.7h0a.7.7,0,0,1-1.4,0v-.7H12.084v.7h0a.7.7,0,0,1-1.4,0v-.7H7.922v.7h0a.7.7,0,0,1-1.4,0v-.7H6.069c-1.692,0-2.414.722-2.414,2.413v11.1c0,1.686.722,2.413,2.414,2.413H16.693c1.692,0,2.414-.722,2.414-2.413Z",
    transform: "translate(-2.25 -1.25)",
    fill: "#fe6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.6e085c431b6e8006c33e118d0406b77f.svg";
export { ForwardRef as ReactComponent };